import type { DefaultPanelConfig } from '@src/types/LayoutConfig';
import { Panel } from '../../../Layout/Components/Panel';
import type { LayoutPanelProps } from '../../types';

export function MarketCapEstimatedPanel({ api }: LayoutPanelProps<DefaultPanelConfig>) {
  return <Panel panelApi={api} data-testid="market-cap-estimated-panel" />;
}
